import { get, post } from 'pc-sales/utils/http';

type state = '0' | '1';

export class NoticeApi {
    // 获取通知列表
    get = async (
        data: {
            page?: number;
            pagesize?: number;
            title?: string;
            state?: state;
            init?: boolean;
            fields?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/message/salesNotice', data, { signal: options?.signal });

    // 获取通知详情
    info = async (data: { msgid: string }) => await get('/v2/message/salesNotice/show', data);

    // 更新通知
    update = async (data: { msgid: string[]; state: state }) => await post('/v2/message/salesNotice/update', data);

    // 删除通知
    destroy = async (data: { msgid: string[] }) => await post('/v2/message/salesNotice/del', data);

    // 获取上下页通知
    pages = async (data: { id: string; state?: state }) => await get('/v2/message/salesNotice/pages', data);

    // 获取强制阅读站内信列表
    forceList = () => get('/v2/message/salesNotice/forceList');

    // 获取含有子级的所有通知类型列表
    getAllManualType = async (data: { language: string }) =>
        await get('/v2/message/salesNotice/getAllManualType', data);

    // 取消订阅
    unsubscribe = async (data: Record<string, any>) => await post('/v2/message/salesNotice/unsubscribe', data);
}

export default new NoticeApi();
